<form [formGroup]="formGroup">
    <kendo-formfield class="reason">
        <div class="d-flex">
            <kendo-label [for]="reason" text="{{ 'dialogue.application.revoke.reason' | translate }}"></kendo-label>
        </div>
        <kendo-textbox #reason
        formControlName="reason"
        showSuccessIcon="initial"
        showErrorIcon="initial"
        preventEmptyFormatter
        [maxlength]=100
         ></kendo-textbox>
    </kendo-formfield>
</form>
<kendo-dialog-actions>
    <button kendoButton class="cancel-button" (click)="onCancelClick()" translate>
        <i></i>&nbsp;
        dialogue.buttons.cancel
    </button>
    <button kendoButton class="confirm-button" (click)="onSubmitClick()" translate>
        <i></i>&nbsp;
        dialogue.buttons.submit
    </button>
</kendo-dialog-actions>